import { render } from "./B2bTableGenralsEmit.vue?vue&type=template&id=c8cf721e&scoped=true&lang=pug"
import script from "./B2bTableGenralsEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableGenralsEmit.vue?vue&type=script&lang=js"

import "./B2bTableGenralsEmit.vue?vue&type=style&index=0&id=c8cf721e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8cf721e"]])

export default __exports__